module.exports = __webpack_public_path__ + "img/shutterstock-1896341410-v-03.957f55df.png";